import './App.css';
import { CookiesProvider } from 'react-cookie';
import Launchpad from './pages/Launchpad';

function App() {
  return (
    <div className="App">
      <CookiesProvider defaultSetOptions={{ path: '/' }}>
        <Launchpad />
      </CookiesProvider>
    </div>
  );
}
export default App;
